import { render, staticRenderFns } from "./ProductMatrixRow.vue?vue&type=template&id=6eaba780&scoped=true&"
import script from "./ProductMatrixRow.vue?vue&type=script&lang=js&"
export * from "./ProductMatrixRow.vue?vue&type=script&lang=js&"
import style0 from "./ProductMatrixRow.vue?vue&type=style&index=0&id=6eaba780&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eaba780",
  null
  
)

export default component.exports